import { pCore, rCore, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';

export const action_async_start = (body: pCore): IPromiseAction<pCore> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OTURUMKAPAT,
    new Api.User.OturumKapat().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rCore | null | undefined,
  error: IError | null | undefined
): IApiAction<rCore> =>
  ActionFunctions.action_async_complete_api<rCore>(ActionSubTypes.API_OTURUMKAPAT, data, error);
